import {http} from '@/http'

export default {
  saveRecord(data) {
    return http.post('/attendance/record', data)
  },
  getRecord(employeeId, date) {
    return http.get(`/attendance/record/${employeeId}/${date}`)
  },
  getMonthRecords(employeeId, year, month) {
    return http.get(`/attendance/month/${employeeId}/${year}/${month}`)
  },
  getMonthGrid(data) {
    return http.post('/attendance/grid', data)
  },
  getSummary(data) {
    return http.post('/attendance/summary', data)
  },
  bulkSave(data) {
    return http.post('/attendance/bulk', data)
  },
  downloadSummaryXlsx(data) {
    return http.post('/attendance/summary/xlsx', data, {responseType: 'blob'})
  },
  downloadTemplate(data) {
    return http.post('/attendance/template/xlsx', data, {responseType: 'blob'})
  },
  uploadExcel(formData, year, month) {
    return http.post(`/attendance/upload?year=${year}&month=${month}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
}
